import React, { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import api, { formatApiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Logo } from "@/components/marketing/Header";
import { toast } from "sonner";

export default function SetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const nav = useNavigate();
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (password !== confirm) {
      toast.error("Passwords do not match");
      return;
    }
    setBusy(true);
    try {
      await api.post("/auth/set-password", { token, password });
      toast.success("Password set — you can sign in now");
      setTimeout(() => nav("/login"), 1200);
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail) || err.message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen bg-slate-50 flex items-center justify-center p-6">
      <form onSubmit={submit} data-testid="set-password-form"
        className="w-full max-w-md space-y-6 bg-white border border-slate-200 rounded-2xl p-10 shadow-sm">
        <Logo />
        <div>
          <h1 className="font-display text-3xl font-medium tracking-tight text-[#0a2540] mt-4">Set your password</h1>
          <p className="text-slate-500 mt-2 text-sm">Choose a password to activate your Interpreta account.</p>
        </div>
        {!token && (
          <div className="text-sm text-rose-600" data-testid="set-password-no-token">
            This link is missing a token. Please use the link from your invite email.
          </div>
        )}
        <div className="space-y-2">
          <Label htmlFor="password">New password</Label>
          <Input id="password" type="password" required minLength={6} value={password}
            data-testid="set-password-input"
            onChange={(e) => setPassword(e.target.value)} placeholder="At least 6 characters" className="h-12" />
        </div>
        <div className="space-y-2">
          <Label htmlFor="confirm">Confirm password</Label>
          <Input id="confirm" type="password" required minLength={6} value={confirm}
            data-testid="set-password-confirm-input"
            onChange={(e) => setConfirm(e.target.value)} placeholder="Repeat your password" className="h-12" />
        </div>
        <Button type="submit" disabled={busy || !token}
          data-testid="set-password-submit-btn"
          className="w-full h-12 rounded-full bg-[#0a2540] hover:bg-[#0a2540]/90 font-semibold">
          {busy ? "Saving…" : "Set password"}
        </Button>
        <div className="text-sm text-slate-500 text-center">
          <Link to="/login" className="text-teal-600 font-medium" data-testid="set-password-login-link">
            Back to sign in
          </Link>
        </div>
      </form>
    </div>
  );
}
